import { createSlice } from '@reduxjs/toolkit';

const name = 'landingForm';

const reducersKeys = {
  getDataRequest: 'getDataRequest',
  getDataSuccess: 'getDataSuccess',
  getDataFailure: 'getDataFailure',

  getMethodsRequest: 'getMethodsRequest',
  getMethodsSuccess: 'getMethodsSuccess',
  getMethodsFailure: 'getMethodsFailure',
};

const initialState = {
  donateForms: [],
  organizations: [],
  methods: [],
  loaded: false,
  loading: false,
  methodsFetching: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDataRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.error = null;
    },
    [reducersKeys.getDataSuccess]: (state, { payload }) => {
      state.donateForms = payload.donateForms;
      state.organizations = payload.organizations;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDataFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.getMethodsRequest]: (state) => {
      state.methodsFetching = true;
      state.error = null;
    },
    [reducersKeys.getMethodsSuccess]: (state, { payload }) => {
      state.methodsFetching = false;
      state.methods = payload.methods;
    },
    [reducersKeys.getMethodsFailure]: (state, { payload }) => {
      state.methodsFetching = false;
      state.error = payload.error;
    },
  },
});

export const { actions } = slice;

export default slice.reducer;
